import React, { useEffect, useRef, useState } from "react";
//New Data table Code Start
import { FilterMatchMode } from "primereact/api";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { IconField } from "primereact/iconfield";
import { InputText } from "primereact/inputtext";
import { Tag } from "primereact/tag";

//New Data table Code End

const ReactDataTable = ({
  cols,
  receiveData,
  test,
  isLoading,
  imageBodyTemplate,
  actionTemplate,
  deleteData,
  statusChange,

  role,
  invite,
  enableMassReceive,
  onMassReceive,
  selection,
  rowClassName,
  userDepartment,
}) => {
  const dt = useRef(null);
  // const [filters2, setFilters2] = useState({
  //   global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  // });
  // const [filters, setFilters] = useState({
  //   status: { value: "active", matchMode: FilterMatchMode.EQUALS },
  // });
  // const [statuses] = useState(["active", "inactive", "unverified"]);

  // const [globalFilter, setGlobalFilter] = useState("");
  // const [statuses] = useState(["active", "inactive", "unverified"]);

  // New way start

  // Check if the "Status" column exists in the cols array
  const hasStatusColumn = cols.some((col) => col.header === "Status");
  // const hasStatusColumn2 = cols.some((col) => col.header === " Status");

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const [statusFilter, setStatusFilter] = useState("active");
  const [statusFilter2, setStatusFilter2] = useState(null);
  const [statuses, setStatuses] = useState([]);
  
  useEffect(() => {
    if (test === true) {
      setStatuses(["active", "inactive", "on_test"]);
    } else {
      setStatuses(["active", "inactive"]);
    }
  }, [test]);
  const [statuses2] = useState([
    "active",
    "approved",
    "received",
    "pending",
    "delivered",
    "damage",
  ]);
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    status: {
      value: hasStatusColumn ? "active" : null,
      matchMode: FilterMatchMode.EQUALS,
    },
    status2: {
      value: null,
      matchMode: FilterMatchMode.EQUALS,
    },
  });

  const [selectedItems, setSelectedItems] = useState([]);

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  // New way end

  const exportColumns = cols.map((col) => ({
    title: col.header,
    dataKey: col.field,
  }));

  const exportPdf = () => {
    import("jspdf").then((jsPDF) => {
      import("jspdf-autotable").then(() => {
        const doc = new jsPDF.default(0, 0);

        // Customize the appearance of the PDF
        doc.setFontSize(4);
        doc.setTextColor(0, 0, 0);
        doc.autoTable({
          head: [exportColumns.map((col) => col.title)],
          body: receiveData.map((data) =>
            exportColumns.map((col) => data[col.dataKey])
          ),
          // theme: "plain",
          styles: {
            halign: "center", // Horizontal alignment
            valign: "middle", // Vertical alignment
          },
        });
        doc.save("products.pdf");
      });
    });
  };

  const exportCSV = (selectionOnly) => {
    dt.current.exportCSV({ selectionOnly });
  };

  const getSeverityAndIcon = (status) => {
    switch (status) {
      case "inactive":
        return { severity: "danger", icon: "pi pi-times" };
      case "active":
        return { severity: "success", icon: "pi pi-check" };
      default:
        return { severity: null, icon: null };
    }
  };

  const getSeverityAndIcon2 = (status2) => {
    switch (status2) {
      case "active":
        return {
          severity: "secondary",
          icon: "pi pi-verified",
          style: { backgroundColor: "green" },
        };
      case "approved":
        return { severity: "success", icon: "pi pi-check-circle" };
      case "received":
        return { severity: "info", icon: "pi pi-check" };
      case "pending":
        return { severity: "warning", icon: "pi pi-clock" };
      case "delivered":
        return {
          severity: "warning",
          icon: "pi pi-circle",
          style: { backgroundColor: "blue" },
        };
      case "damage":
        return {
          severity: "warning",
          icon: "pi pi-info-circle",
          style: { backgroundColor: "#ff1919" },
        };
      default:
        return { severity: null, icon: null };
    }
  };

  // const statusBodyTemplate = (rowData) => {
  //   console.log(rowData)
  //   return (
  //     <Tag value={rowData.status} severity={getSeverity(rowData.status)} />
  //   );
  // };

  // const statusBodyTemplate = (rowData) => {
  //   return (
  //     <Tag value={rowData.status} severity={getSeverityAndIcon(rowData.status)} />
  //   );
  // };

  const statusBodyTemplate = (rowData) => {
    return (
      <Tag {...getSeverityAndIcon(rowData.status)} value={rowData.status} />
    );
  };

  const statusItemTemplate = (option) => {
    return <Tag {...getSeverityAndIcon(option)} value={option} />;
  };

  const statusBodyTemplate2 = (rowData) => {
    return (
      <Tag {...getSeverityAndIcon2(rowData.status)} value={rowData.status} />
    );
  };

  const statusItemTemplate2 = (option) => {
    return <Tag {...getSeverityAndIcon2(option)} value={option} />;
  };

  // const statusRowFilterTemplate = (options) => {
  //   return (
  //     <Dropdown
  //       value={options.value}
  //       options={statuses}
  //       onChange={(e) => options.filterApplyCallback(e.value)}
  //       itemTemplate={statusItemTemplate}
  //       placeholder="Select One"
  //       className="p-column-filter"
  //       showClear
  //       style={{ Width: "1px" }}
  //     />
  //   );
  // };

  const handleMassReceive = () => {
    if (selectedItems.length > 0 && onMassReceive) {
      onMassReceive(selectedItems);
      setSelectedItems([]);
    }
  };

  const isSelectable = (rowData) => {
    // First check if this is an incoming transfer to the user's department
    if (rowData.to_department_art_id !== userDepartment) {
      return false;
    }

    // Then check receive quantities based on role
    if (role === "dfw") {
      return (
        rowData.receive_qty_export < 1 &&
        rowData.receive_qty_a_class < 1 &&
        rowData.receive_qty_b_class < 1 &&
        rowData.receive_qty_c_class < 1
      );
    } else if (role === "decoration_firing") {
      return (
        rowData.receive_qty < 1 &&
        rowData.receive_qty_export < 1 &&
        rowData.receive_qty_a_class < 1 &&
        rowData.receive_qty_b_class < 1 &&
        rowData.receive_qty_c_class < 1
      );
    } else if (role === "decoration_local") {
      return (
        rowData.receive_qty < 1 &&
        rowData.receive_qty_a_class < 1 &&
        rowData.receive_qty_b_class < 1 &&
        rowData.receive_qty_c_class < 1
      );
    } else if (role === "packing_local") {
      return (
        rowData.receive_master_qty < 1 &&
        rowData.receive_inner_qty < 1 &&
        rowData.receive_qty < 1 &&
        rowData.receive_qty_a_class < 1 &&
        rowData.receive_qty_b_class < 1 &&
        rowData.receive_qty_c_class < 1
      );
    } else if (role === "packing_export") {
      return (
        rowData.receive_master_qty < 1 &&
        rowData.receive_inner_qty < 1 &&
        rowData.receive_qty < 1 &&
        rowData.receive_qty_export < 1
      );
    } else if (role === "decoration_export") {
      return rowData.receive_qty < 1 && rowData.receive_qty_export < 1;
    } else {
      // For other roles
      return rowData.receive_qty < 1;
    }
  };

  // Custom row selection function
  const onSelectionChange = (e) => {
    // Filter out non-selectable items from the selection
    const selectableItems = e.value.filter(isSelectable);
    setSelectedItems(selectableItems);
  };

  const header = () => (
    <div className="d-flex justify-content-between reactDataTable">
      <div className="headerIcons">
        {enableMassReceive && selectedItems.length > 0 && (
          <Button
            type="button"
            icon="pi pi-check"
            severity="success"
            rounded
            onClick={handleMassReceive}
            tooltip="Receive Selected Items"
            className="me-2"
          />
        )}
        <Button
          type="button"
          icon="pi pi-file"
          rounded
          onClick={() => exportCSV(false)}
          data-pr-tooltip="CSV"
          title="CSV"
        />
        <Button
          type="button"
          icon="pi pi-file-pdf"
          severity="warning"
          rounded
          onClick={exportPdf}
          data-pr-tooltip="PDF"
          title="PDF"
        />
      </div>
      <span>
        {cols.some((col) => col.header === "Status") && (
          <Dropdown
            value={statusFilter}
            options={statuses}
            onChange={(e) => {
              setStatusFilter(e.value);
              dt.current.filter(e.value, "status", "equals");
            }}
            itemTemplate={statusItemTemplate}
            placeholder="Select One"
            className="p-column-filter"
            showClear
          />
        )}
        {cols.some((col) => col.header === " Status") && (
          <Dropdown
            value={statusFilter2}
            options={statuses2}
            onChange={(e) => {
              setStatusFilter2(e.value);
              dt.current.filter(e.value, "status", "equals");
            }}
            itemTemplate={statusItemTemplate2}
            placeholder="Select One"
            className="p-column-filter"
            showClear
          />
        )}
      </span>
      <span className="searching">
        <IconField iconPosition="left">
          {/* <InputIcon className="pi pi-search" /> */}
          <InputText
            value={globalFilterValue}
            onChange={onGlobalFilterChange}
            placeholder="Search"
          />
        </IconField>
        {/* <InputText
          placeholder="Search"
          onInput={(e) =>
            setGlobalFilter({
              global: {
                value: e.target.value,
                matchMode: FilterMatchMode.CONTAINS,
              },
            })
          }
        /> */}
      </span>
    </div>
  );

  const footer = `Total rows:  ${receiveData ? receiveData.length : 0}`;

  return (
    <div>
      <DataTable
        footer={footer}
        resizableColumns
        stripedRows
        showGridlines
        filters={filters}
        paginator
        loading={isLoading}
        rows={50}
        rowsPerPageOptions={[10, 50, 100, 500, 1000]}
        ref={dt}
        value={receiveData}
        header={header}
        emptyMessage="No Data Found !"
        scrollable
        scrollHeight="400px"
        selection={selectedItems}
        onSelectionChange={onSelectionChange}
        selectionMode={enableMassReceive ? "checkbox" : null}
        dataKey="id"
        selectableRows={isSelectable}
        rowClassName={rowClassName}
      >
        {/* {detailOnName && (
          <Column removableSort header="Name" body={detailOnName} />
        )} */}
        {imageBodyTemplate && (
          <Column header="Image" body={imageBodyTemplate} />
        )}

        {enableMassReceive && (
          <Column
            selectionMode="multiple"
            headerStyle={{ width: "3rem" }}
            selectionAriaLabel="selection"
          />
        )}

        {cols.map((col, index) => (
          <Column
            style={{ width: "1pxy" }}
            // sortable
            key={index}
            field={col.field}
            header={col.header}
            body={
              col.header === "Status"
                ? statusBodyTemplate
                : col.header === " Status"
                ? statusBodyTemplate2
                : null
            }

            // {...(col.header === "Status" && {
            //   showFilterMenu: false,
            //   filterMenuStyle: { width: "1px" },
            //   filter: true,
            //   filterElement: statusRowFilterTemplate,
            // })}
          />
        ))}

        {actionTemplate && (
          <Column
            style={{ width: "5%" }}
            header="Actions"
            body={(item) =>
              actionTemplate(item, deleteData, role || statusChange || invite)
            }
          />
        )}

        {/* <Column
          header="Name"
          body={(rowData) => detailOnName(rowData)}
        /> */}
      </DataTable>
    </div>
  );
};

export default ReactDataTable;
